import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook from React Router
import LoadingPage from './LoadingPage'; // Assuming you have a LoadingPage component

const npkStyle = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%', // Full width of the screen
    height: '100vh', // Full viewport height
    display: 'flex',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    backdropFilter: 'blur(3px)', // Subtle background blur
    fontFamily: "'Poppins', sans-serif",
    overflow: 'hidden',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  formContainer: {
    background: 'rgba(255, 255, 255, 0.2)', // Slight transparency for a glass effect
    backdropFilter: 'blur(10px)', // Slight blur for glass effect
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)', // Slightly stronger shadow
    textAlign: 'center',
    maxWidth: '950px',
    width: '60%',
    height: '80vh', // Adjust the height to be 80% of the viewport height
    border: '2px solid #f1f8e9',
    display: 'flex',
    flexDirection: 'column', // Stack the title and crop cards vertically
  },
  h3: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: '1.8rem', // Slightly larger font size
    padding: '12px',
    color: '#FFFFFF',
    fontWeight: '600',
    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.3)',
  },
  cropsWrapper: {
    flex: '1',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '12px',
    padding: '10px 0',
    overflowY: 'auto',
    marginTop: '20px',
  },
  cropCard: {
    padding: '18px 10px',
    border: '2px solid #ccc',
    borderRadius: '12px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: '90px',
    maxWidth: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    wordWrap: 'break-word',
    boxSizing: 'border-box',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3))',
  },
  cropIcon: {
    fontSize: '30px', // Larger icon for visibility
  },
  cropName: {
    fontSize: '14px',
    fontWeight: '600',
    marginTop: '8px',
    color: '#333',
    whiteSpace: 'normal',
    overflow: 'hidden',
    wordWrap: 'break-word',
  },
};

const cropOptions = {
  paddy: '🌾',         // Rice
  cholam: '🌽',        // Sorghum (Cholam)
  cumbo: '🌾',         // Pearl Millet (Cumbu)
  ragi: '🌾',          // Finger Millet (Ragi)
  maize: '🌽',         // Maize
  redGram: '🌰',       // Red Gram (Pulses)
  bengalGram: '🍛',    // Bengal Gram (Chickpea)
  greenGram: '🍀',     // Green Gram (Moong)
  blackGram: '🌑',     // Black Gram (Urad Dal)
  horseGram: '🐎',     // Horse Gram
  groundnut: '🥜',     // Groundnut (Peanut)
  gingelly: '🌰',      // Sesame (Gingelly)
  potato: '🥔',        // Potato
  onion: '🧅',         // Onion
  sugarcane: '🍬',     // Sugarcane
  cotton: '🌻',        // Cotton
};

const CropList = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  const handleCropClick = (crop) => {
    // Navigate to the CropDetail page with the selected crop
    navigate(`/crop-detail/${crop}`);
  };

  return (
    <div style={npkStyle.container}>
      <div style={npkStyle.formContainer}>
        <h3 style={npkStyle.h3}>Crop List</h3>
        <div style={npkStyle.cropsWrapper}>
          {Object.keys(cropOptions).map((crop) => {
            return (
              <div
                key={crop}
                onClick={() => handleCropClick(crop)} // Navigate to the CropDetail page on click
                style={npkStyle.cropCard}
              >
                <div style={npkStyle.cropIcon}>{cropOptions[crop]}</div>
                <div style={npkStyle.cropName}>{crop}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CropList;
